import React, { Component } from 'react';
import { getQuiz } from '../../actions';
import classNames from 'classnames';

class SelectFieldQuiz extends Component {
  constructor(props) {
    super(props)
    this.state = {
      options: []
    }
  }
  
  
  async componentDidMount() {
    try {
      let quizs = await getQuiz();
      this.setState({options: quizs})
    } catch (error) {
      
    }
  }
  render() {
    const {input, type, disabled, meta: { touched, error }, placeholder, label, } = this.props;
    const { options } = this.state;
    return (
      <div className={classNames("create-dialog-form__group create-dialog-form__group--indent-bottom", {disabled})}>
        {label ? <label >{label}</label> : null}
          <select {...input} disabled={disabled} className="create-dialog-form__control" >
            <option></option>
            {options.map(option => <option key={'quiz-' + option.id} value={option.id}>{option.title}</option>)}
          </select>
        {touched && ((error && <span style={{color: 'red'}}>{error}</span>))}
      </div>
    );
  }
}

export default SelectFieldQuiz;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmQuiz/components/FormContent/SelectField.js